export const TASK_COMPLETION_DELAY = 5000;
